<template>
  <v-dialog v-model="Vue.$store.state.authVar.recovery" max-width="500px">
    <v-card class="auth-card">
      <v-card-title>
        <span class="headline">{{$t('auth.recoveryTitle')}}</span><v-spacer></v-spacer>
        <v-btn icon @click="closeRecovery">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 class="text-xs-center" v-html="$t('auth.recoveryText')">
          </v-flex>
          <v-flex xs12>
            <v-text-field
              prepend-icon="email"
              v-model="email" :rules="rules" :label="$t('auth.mail')" required></v-text-field>
          </v-flex>
<!--          <v-flex xs12>-->
<!--            <v-text-field-->
<!--              label="069-00-00-00"-->
<!--              prepend-icon="phone"-->
<!--              mask="###-##-##-##"-->
<!--              single-line-->
<!--              v-model="phone"-->
<!--              :rules="rules"-->
<!--            ></v-text-field>-->
<!--          </v-flex>-->
          <v-flex xs12>
            <v-btn block color="secondary" :loading="sending" :disabled="sending" @click="recover">{{$t('auth.recover')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import UserFunc from '@/components/partials/AuthForm'
export default {
  name: 'recovery',
  data () {
    return {
      Vue: this,
      email: '',
      phone: '',
      rules: [(value) => !!value || this.$t('auth.required')],
      sending: false
    }
  },
  methods: {
    recover () {
      let Vue = this
      if (this.email.length < 5 || this.email.indexOf('@') === -1) {
        Vue.$notice['warning']({
          title: Vue.$t('auth.warning'),
          description: Vue.$t('auth.field_required')
        })
      } else {
        UserFunc.recover(Vue)
      }
    },
    closeRecovery () {
      this.$store.commit('var', { type: 'authVar', i: 'recovery', v: false })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/AuthForm/recovery.vue